export class TransactionDto{
    noOfVisitors : string;
    hodStatus : string ;
    hrStatus : string;
    created_at: Date;
}